import {
    getPurchasePlans,
    deletePurchasePlan,
    createPurchasePlan,
    updatePurchasePlan
} from '../../../services/PurchasePlanService';
import {
    CONFIRMED_GET_PURCHASEPLANS
} from './PurchasePlanTypes';

export function getPurchasePlansAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
            dispatch({ type: 'PURCHASE_PLAN_LOADING' });
            getPurchasePlans(currentPage, pageSize, searchTerm, filterQuery)
                .then((response) => {
                    dispatch(confirmedGetPurchasePlansAction(response.data.data));
                })
                .catch(() => {
                    dispatch(confirmedGetPurchasePlansAction({ rows: [], count: 0, pages: 1 }));
                });
    };
}

export function confirmedGetPurchasePlansAction(data) {
    return {
        type: CONFIRMED_GET_PURCHASEPLANS,
        payload: data,
    };
}

export function deletePurchasePlanAction(id, history) {
    return (dispatch, getState) => {
        return deletePurchasePlan(id).then((response) => {
            return response;
        });
    };
}

export function createPurchasePlanAction(data) {
    return () => {
        return createPurchasePlan(data).then((response) => {
            return response;
        });
    };
}

export function updatePurchasePlanAction(id, data) {
    return () => {
        return updatePurchasePlan(id, data).then((response) => {
            return response;
        });
    };
}